module.exports = __webpack_public_path__ + "static/media/YF68_0.abed4eed.jpg";